import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { PurchaseService } from './purchase.service';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({ providedIn: 'root' })
export class PurchaseResolver {
  constructor(private purchaseService: PurchaseService, private logService: LoggingService) {}

  resolve(route: ActivatedRouteSnapshot) {
    let currentUrl: string = route.pathFromRoot
      .filter((x) => x.routeConfig)
      .map((x) => x.routeConfig!.path)
      .join('/');

    this.logService.info(`Resolving all member purchases for route: ${currentUrl}`);
    return this.purchaseService.fetchMemberPurchases();
  }
}
